var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { level: 2, styling: "page-title" } }, [
        _vm._v("Impressum"),
      ]),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("Card", { staticClass: "card" }, [
            _c("span", { staticClass: "paragraph_sign" }, [_vm._v("§")]),
            _c("p", [
              _vm._v(" Ehrengarde der Stadt Neuwied e.V. "),
              _c("br"),
              _c(
                "a",
                { attrs: { href: "mailto:info@ehrengarde-neuwied.de" } },
                [_vm._v("info@ehrengarde-neuwied.de")]
              ),
            ]),
            _c("p", [
              _vm._v(" Präsident "),
              _c("br"),
              _vm._v(" Stefan Kugler "),
              _c("br"),
              _vm._v(" Elisabethstraße 38 "),
              _c("br"),
              _vm._v(" Neuwied 56564 "),
              _c("br"),
              _c("a", { attrs: { href: "tel:+492631958788" } }, [
                _vm._v("(+49) 2631 958 788"),
              ]),
              _c("br"),
            ]),
            _c("p", [
              _vm._v(" Eingetragen beim Amtsgericht Montabaur "),
              _c("br"),
              _vm._v(" unter Vereinsregister Nr. 11338 "),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }